import { BeachElementType } from '../jotai-modules/types'
import { isFacility } from '../utils/util'
import type { BeachPlanSpotIconMaxWidths } from '../../../types/beachPlan.types'

export const DEFAULT_SPOT_ICON_MAX_WIDTHS: BeachPlanSpotIconMaxWidths = {
  facilities: 50,
  cabana: 75,
  umbrella: 75,
  pouf: 60,
}

export const resolveSpotIconMaxWidth = (type?: BeachElementType, configuredMaxWidths?: BeachPlanSpotIconMaxWidths): number | undefined => {
  const maxWidths = { ...DEFAULT_SPOT_ICON_MAX_WIDTHS, ...configuredMaxWidths }

  if (type && isFacility(type)) {
    return maxWidths.facilities
  }

  switch (type) {
    case BeachElementType.CABANA:
      return maxWidths.cabana
    case BeachElementType.UMBRELLA:
      return maxWidths.umbrella
    case BeachElementType.POUF:
      return maxWidths.pouf
    default:
      return undefined
  }
}
